// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLastYearDataButton_root__bp2co","text":"PlasmicLastYearDataButton_text__6EmC+"};